import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  hrmsRoleSearch: {
    cursor: "pointer",
    margin: "5px 0px",
  },
}));
const RoleSearch = ({ highlightText, item }) => {
  const navigate = useNavigate();
  const classes = useStyle();
  const handleRedirect = () => {
    navigate("/roles");
  };
  return (
    <Grid className={classes.hrmsRoleSearch} onClick={handleRedirect}>
      <Typography>{highlightText(item.role_name)}</Typography>
    </Grid>
  );
};

export default RoleSearch;
